import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";

const DashboardRedirect = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  useEffect(() => {
    // If not admin, redirect to subordinate page
    if (role !== "admin") {
      navigate("/subordinate", { replace: true });
    }
  }, [role, navigate]);

  // Only show AdminDashboard if role is admin
  if (role === "admin") {
    return <AdminDashboard />;
  }

  // Show loading or null while redirecting
  return null;
};

export default DashboardRedirect;
